import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const BIZ_TZ = "Asia/Kolkata";

export const dateStrIST = (ms = Date.now()) => new Date(ms).toLocaleDateString("en-CA", { timeZone: BIZ_TZ });

export const todayStr = () => dateStrIST();

export const nowHM = () =>
  new Date().toLocaleTimeString("en-GB", { timeZone: BIZ_TZ, hour: "2-digit", minute: "2-digit", hour12: false });

export const fmtDay = (d) =>
  d ? new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";
